export default "__VITE_ASSET__GshEbQpG__"